import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Layout, Rocket, CheckCircle2 } from 'lucide-react';
type Plan = {
  icon: React.ReactNode;
  name: string;
  badge: string;
  description: string;
  price: string;
  sections?: string[];
  features: string[];
  highlighted: boolean;
};
export function Pricing() {
  const plans: Plan[] = [{
    icon: <FileText size={32} className="text-nova-accent" data-id="element-282" />,
    name: 'LANDING PAGE',
    badge: '',
    description: 'Ideal para negocios que necesitan una presencia web clara, rapida y profesional para generar confianza y facilitar el contacto con sus clientes.',
    price: '597.000',
    sections: ['Hero principal con titulo y llamado a la accion', 'Servicios detallados con descripcion y precios', 'Testimonios de clientes reales', 'Redes sociales integradas', 'Contacto con formulario y boton de WhatsApp'],
    features: ['Diseno web profesional', 'Diseno responsive adaptado a cualquier dispositivo movil, tablet y escritorio', 'Estructura orientada a conversion', 'Boton de WhatsApp directo', 'Google Maps integrado', 'Formulario de contacto', 'Seccion de testimonios de clientes', 'Integracion de redes sociales', 'Redaccion basica de textos incluida', 'Hosting y dominio por 1 año', 'Certificado SSL incluido', 'SEO basico configurado', 'Soporte tecnico por 30 dias'],
    highlighted: false
  }, {
    icon: <Layout size={32} className="text-white" data-id="element-283" />,
    name: 'SITIO WEB PROFESIONAL',
    badge: 'MAS POPULAR',
    description: 'Para negocios que necesitan una pagina mas completa con mejor estructura para presentar sus servicios, su marca y sus canales de contacto de forma profesional.',
    price: '897.000',
    features: ['Diseno web profesional moderno', 'Diseno responsive adaptado a cualquier dispositivo movil, tablet y escritorio', 'Estructura orientada a conversion', 'Hasta 6 secciones bien estructuradas', 'Menu de navegacion incluido', 'Boton de WhatsApp directo', 'Google Maps integrado', 'Formulario de contacto', 'Galeria de fotos del negocio', 'Seccion de servicios detallados', 'Seccion de testimonios de clientes', 'Integracion de redes sociales', 'Redaccion intermedia de textos incluida', 'Logotipo basico en PNG incluido', 'Hosting y dominio por 1 año', 'Certificado SSL incluido', 'SEO optimizado', 'Soporte tecnico por 60 dias'],
    highlighted: true
  }, {
    icon: <Rocket size={32} className="text-nova-accent" data-id="element-284" />,
    name: 'SITIO WEB AVANZADO',
    badge: '',
    description: 'Para negocios que necesitan una pagina avanzada con funcionalidades completas logrando una presencia digital solida, moderna y profesional.',
    price: '1.497.000',
    features: ['Diseno web profesional premium', 'Diseno responsive adaptado a cualquier dispositivo movil, tablet y escritorio', 'Estructura orientada a conversion', 'Hasta 8 secciones bien estructuradas', 'Menu de navegacion incluido', 'Boton de WhatsApp directo', 'Google Maps integrado', 'Formulario de contacto', 'Galeria de fotos del negocio', 'Seccion de servicios detallados', 'Tienda virtual con pasarela de pagos', 'Catalogo de productos o menu digital, carga inicial hasta 20 productos', 'Formulario de reservas o citas online', 'Seccion de testimonios de clientes', 'Integracion de redes sociales', 'Redaccion completa de textos incluida', 'Logotipo incluido con paleta de colores y tipografias definidas', 'Animaciones y efectos visuales', 'Seccion de blog o noticias', 'Google Analytics instalado', 'Hosting y dominio por 1 año', 'Certificado SSL incluido', 'SEO avanzado optimizado', 'Soporte tecnico por 90 dias'],
    highlighted: false
  }];
  return <section id="servicios" className="py-32 bg-nova-bg-alt" data-id="element-285">
      <div className="max-w-7xl mx-auto px-6" data-id="element-286">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-287">
          <h2 className="text-4xl font-bold text-nova-text mb-4" data-id="element-288">
            Nuestros Paquetes
          </h2>
          <p className="text-nova-text-muted text-lg max-w-2xl mx-auto" data-id="element-289">
            Soluciones web profesionales para negocios locales
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch" data-id="element-290">
          {plans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`relative rounded-2xl p-8 flex flex-col ${plan.highlighted ? 'shadow-2xl md:scale-105' : 'bg-nova-bg border border-nova-card'}`} style={plan.highlighted ? {
          backgroundColor: '#1E3A5F',
          border: '2px solid #38BDF8',
          boxShadow: '0 0 40px rgba(56, 189, 248, 0.25)'
        } : undefined} data-id="element-291">
              {plan.badge ? <div className="absolute -top-4 left-1/2 -translate-x-1/2 text-xs font-bold px-4 py-1 rounded-full" style={{
            backgroundColor: '#FFFFFF',
            color: '#1E3A5F'
          }} data-id="element-292">
                  {plan.badge}
                </div> : null}

              <div className="mb-4" data-id="element-293">{plan.icon}</div>
              <h3 className={`text-xl font-bold mb-2 ${plan.highlighted ? 'text-white' : 'text-nova-text'}`} data-id="element-294">
                {plan.name}
              </h3>
              <p className={`text-sm mb-4 ${plan.highlighted ? 'text-white/80' : 'text-nova-text-muted'}`} data-id="element-295">
                {plan.description}
              </p>
              <div className={`text-3xl font-bold mb-6 ${plan.highlighted ? 'text-white' : 'text-nova-text'}`} data-id="element-296">
                ${plan.price}{' '}
                <span className="text-sm font-normal opacity-80" data-id="element-297">COP</span>
              </div>

              {plan.sections && plan.sections.length > 0 ? <div className="mb-6" data-id="element-298">
                  <h4 className={`text-sm font-semibold mb-3 ${plan.highlighted ? 'text-white' : 'text-nova-text'}`} data-id="element-299">
                    Estructura de la pagina:
                  </h4>
                  <ul className="space-y-2" data-id="element-300">
                    {plan.sections.map((section, i) => <li key={i} className={`flex items-start gap-2 text-sm ${plan.highlighted ? 'text-white/90' : 'text-nova-text-muted'}`} data-id="element-301">
                        <span className={`mt-1 shrink-0 w-1.5 h-1.5 rounded-full ${plan.highlighted ? 'bg-[#38BDF8]' : 'bg-nova-accent'}`} data-id="element-302" />
                        <span data-id="element-303">{section}</span>
                      </li>)}
                  </ul>
                  <div className={`h-px w-full my-5 ${plan.highlighted ? 'bg-white/10' : 'bg-nova-card'}`} data-id="element-304" />
                </div> : null}

              <ul className="space-y-2 mb-8 flex-1" data-id="element-305">
                {plan.features.map((feature, i) => <li key={i} className={`flex items-start gap-2 text-sm ${plan.highlighted ? 'text-white/90' : 'text-nova-text-muted'}`} data-id="element-306">
                    <CheckCircle2 size={16} className={`mt-0.5 shrink-0 ${plan.highlighted ? 'text-[#38BDF8]' : 'text-nova-accent'}`} data-id="element-307" />
                    <span data-id="element-308">{feature}</span>
                  </li>)}
              </ul>

              <a href="#contacto" className={`block w-full py-3 rounded-xl font-semibold text-center transition-all hover:opacity-90 ${plan.highlighted ? '' : 'bg-gradient-to-r from-[#00D4FF] to-[#0080FF] text-nova-bg shadow-[0_0_15px_rgba(0,212,255,0.3)]'}`} style={plan.highlighted ? {
            backgroundColor: '#FFFFFF',
            color: '#1E3A5F'
          } : undefined} data-id="element-309">
                Cotizar ahora
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}